// extracted by mini-css-extract-plugin
export default {"iconWrapper":"SavingIcon_iconWrapper__tnQZO","iconWrapper--saving":"SavingIcon_iconWrapper--saving__LMa+i","iconWrapper--saved":"SavingIcon_iconWrapper--saved__3mCOp"};